import { BaseApi } from './base.api.js';

export class WebhookSubscriptionApi extends BaseApi {
    constructor(client) {
        super(client, '/webhook-subscription');
    }

    test(id) { return this.client.post(`${this.basePath}/${id}/test`, {}).then((r) => r.data); }

    listDeliveries(id, params = {}) {
        return this.client.get(`${this.basePath}/${id}/deliveries`, { params }).then((r) => r.data);
    }

    replayDelivery(id, deliveryId) {
        return this.client.post(`${this.basePath}/${id}/deliveries/${deliveryId}/replay`, {}).then((r) => r.data);
    }

    rotateSecret(id) {
        return this.client.post(`${this.basePath}/${id}/rotate-secret`, {}).then((r) => r.data);
    }
}
